module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.1502ba35.png";